var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('game-extrastars',{attrs:{"intro-sprite":"/images/game/w4d1/robi_extrapoints_statistic.png","intro-text":_vm.$lang.get('w4d1.game4.stars', {br: '\n'}),"questions":[
        {
            questiontext: _vm.$lang.get('w4d1.game4.table'),
            bubbleText: _vm.$lang.get('w4d1.game4.remember'),
            answerFontSize: 22,
            answers: [
                {
                    option: _vm.$lang.get('w4d1.game4.list'),
                    correct: false
                },
                {
                    option: _vm.$lang.get('w4d1.game4.data'),
                    correct: false
                },
                {
                    option: _vm.$lang.get('w4d1.game4.spelling'),
                    correct: true
                }
            ]
        },
        {
            questiontext: _vm.$lang.get('w4d1.game4.rows'),
            bubbleText: _vm.$lang.get('w4d1.game4.video'),
            answers: [
                {
                    option: _vm.$lang.get('w4d1.game4.line'),
                    correct: false
                },
                {
                    option: _vm.$lang.get('w4d1.game4.columns'),
                    correct: true
                },
                {
                    option: _vm.$lang.get('w4d1.game4.circle'),
                    correct: false
                }
            ]
        }
    ]}})}
var staticRenderFns = []

export { render, staticRenderFns }